module.exports = __webpack_public_path__ + "static/media/Aparna R.79bfdb5e.jpg";